import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Page from "../../components/Page";

export default function DichiarazioneSelvaggina() {
    const { ricevimentoId } = useParams();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const today = new Date().toISOString().slice(0, 10);

    const [d, setD] = useState({
        ricevimento_id: Number(ricevimentoId),
        data_dichiarazione: today,
        numero_dichiarazione: "",
        cacciatore_nome: "",
        cacciatore_qualifica: "SINGOLO",
        squadra_numero: "",
        cacciatore_qualifica_altro: "",
        attestato_rilasciato_da: "",
        attestato_data: "",

        abbattimento_data_ora: "", // "YYYY-MM-DDTHH:MM"
        abbattimento_comune: "",
        abbattimento_provincia: "",
        abbattimento_atc: "",
        abbattimento_gps: "",

        specie_tipo: "GROSSA",
        specie_descrizione: "",
        quantita: 1,
        fascetta_id: "",
        note_specie: "",

        chk_nessuna_anomalia: 0,
        chk_esame_ok: 0,
        chk_conservazione_ok: 0,
        chk_cessione_non_commerciale: 0,

        firma_cacciatore: "",
        firma_data: today,

        destinatario_indirizzo: "",
        destinatario_comune: "",
        destinatario_provincia: "",
        destinatario_piva: "",
        destinatario_responsabile: "",
        destinatario_firma: "",
        destinatario_data: "",
    });

    useEffect(() => {
        let alive = true;
        (async () => {
            setLoading(true);
            try {
                const r = await fetch(`/api/selvaggina_get.php?ricevimento_id=${encodeURIComponent(ricevimentoId)}`, {
                    credentials: "include",
                });
                const data = await r.json();
                if (!alive) return;
                if (data?.success && data?.item) {
                    setD((p) => ({ ...p, ...data.item, ricevimento_id: Number(ricevimentoId) }));
                }
            } catch {
                // ok: resta form vuoto
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, [ricevimentoId]);

    const save = async () => {
        setSaving(true);
        try {
            const res = await fetch("/api/selvaggina_save.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(d),
            });
            const data = await res.json();
            alert(data?.message || "Salvato");
        } catch {
            alert("Errore salvataggio");
        } finally {
            setSaving(false);
        }
    };

    const stampa = () => {
        window.open(`/api/selvaggina_print.php?ricevimento_id=${encodeURIComponent(ricevimentoId)}`, "_blank");
    };

    if (loading) {
        return (
            <Page title="Dichiarazione Selvaggina" back>
                <div className="p-4 max-w-3xl mx-auto text-sm text-slate-600">Caricamento...</div>
            </Page>
        );
    }

    return (
        <Page title="Dichiarazione Selvaggina" back>
            <div className="p-4 max-w-3xl mx-auto space-y-4">

                <div className="bg-white border border-slate-200 rounded-xl p-4">
                    <div className="text-sm text-slate-600">
                        Collegata al ricevimento ID: <strong>{ricevimentoId}</strong>
                    </div>
                </div>

                <div className="bg-white border border-slate-200 rounded-xl p-4 space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="block text-sm font-medium">Data dichiarazione</label>
                            <input type="date" className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.data_dichiarazione}
                                onChange={(e) => setD(p => ({ ...p, data_dichiarazione: e.target.value }))}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">Numero dichiarazione (progressivo cacciatore)</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.numero_dichiarazione}
                                onChange={(e) => setD(p => ({ ...p, numero_dichiarazione: e.target.value }))}
                            />
                        </div>
                    </div>

                    <h3 className="font-semibold pt-2">Dati del cacciatore</h3>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="block text-sm font-medium">Nome e Cognome</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.cacciatore_nome}
                                onChange={(e) => setD(p => ({ ...p, cacciatore_nome: e.target.value }))}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">Qualifica</label>
                            <select className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.cacciatore_qualifica}
                                onChange={(e) => setD(p => ({ ...p, cacciatore_qualifica: e.target.value }))}
                            >
                                <option value="SINGOLO">Cacciatore singolo</option>
                                <option value="SQUADRA">Squadra</option>
                                <option value="SELETTORE">Selettore</option>
                                <option value="ALTRO">Altro</option>
                            </select>
                        </div>
                    </div>

                    {d.cacciatore_qualifica === "SQUADRA" && (
                        <div>
                            <label className="block text-sm font-medium">Numero squadra</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.squadra_numero}
                                onChange={(e) => setD(p => ({ ...p, squadra_numero: e.target.value }))}
                            />
                        </div>
                    )}

                    {d.cacciatore_qualifica === "ALTRO" && (
                        <div>
                            <label className="block text-sm font-medium">Specifica qualifica</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.cacciatore_qualifica_altro}
                                onChange={(e) => setD(p => ({ ...p, cacciatore_qualifica_altro: e.target.value }))}
                            />
                        </div>
                    )}

                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="block text-sm font-medium">Attestato rilasciato da (ente)</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.attestato_rilasciato_da}
                                onChange={(e) => setD(p => ({ ...p, attestato_rilasciato_da: e.target.value }))}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">Data attestato</label>
                            <input type="date" className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.attestato_data || ""}
                                onChange={(e) => setD(p => ({ ...p, attestato_data: e.target.value }))}
                            />
                        </div>
                    </div>

                    <h3 className="font-semibold pt-2">Dettagli abbattimento</h3>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="block text-sm font-medium">Data e ora abbattimento</label>
                            <input type="datetime-local" className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.abbattimento_data_ora || ""}
                                onChange={(e) => setD(p => ({ ...p, abbattimento_data_ora: e.target.value }))}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">ATC</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.abbattimento_atc}
                                onChange={(e) => setD(p => ({ ...p, abbattimento_atc: e.target.value }))}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="block text-sm font-medium">Comune</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.abbattimento_comune}
                                onChange={(e) => setD(p => ({ ...p, abbattimento_comune: e.target.value }))}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">Provincia</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.abbattimento_provincia}
                                onChange={(e) => setD(p => ({ ...p, abbattimento_provincia: e.target.value }))}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium">GPS / descrizione precisa (opzionale)</label>
                        <input className="mt-1 w-full border rounded-md px-3 py-2"
                            value={d.abbattimento_gps}
                            onChange={(e) => setD(p => ({ ...p, abbattimento_gps: e.target.value }))}
                        />
                    </div>

                    <h3 className="font-semibold pt-2">Specie cedute</h3>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="block text-sm font-medium">Tipo</label>
                            <select className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.specie_tipo}
                                onChange={(e) => setD(p => ({ ...p, specie_tipo: e.target.value }))}
                            >
                                <option value="GROSSA">Selvaggina grossa</option>
                                <option value="PICCOLA">Selvaggina piccola</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium">Specie (es. Cinghiale, Fagiano…)</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.specie_descrizione}
                                onChange={(e) => setD(p => ({ ...p, specie_descrizione: e.target.value }))}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-3 gap-3">
                        <div>
                            <label className="block text-sm font-medium">Quantità</label>
                            <input type="number" className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.quantita}
                                onChange={(e) => setD(p => ({ ...p, quantita: Number(e.target.value || 1) }))}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-medium">Fascetta/ID (richiesto per grossa)</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.fascetta_id}
                                onChange={(e) => setD(p => ({ ...p, fascetta_id: e.target.value }))}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium">Note (peso, ecc.)</label>
                        <input className="mt-1 w-full border rounded-md px-3 py-2"
                            value={d.note_specie}
                            onChange={(e) => setD(p => ({ ...p, note_specie: e.target.value }))}
                        />
                    </div>

                    <h3 className="font-semibold pt-2">Dichiarazione del cacciatore</h3>
                    {[
                        ["chk_nessuna_anomalia", "Prima dell’abbattimento non osservate anomalie o segni di malattia."],
                        ["chk_esame_ok", "Esame preliminare post-abbattimento senza anomalie/contaminazioni."],
                        ["chk_conservazione_ok", "Conservazione/trasporto in condizioni igieniche e a temperatura adeguata."],
                        ["chk_cessione_non_commerciale", "Cessione diretta e non commerciale."],
                    ].map(([k, label]) => (
                        <label key={k} className="flex items-start gap-2 text-sm">
                            <input
                                type="checkbox"
                                checked={!!d[k]}
                                onChange={(e) => setD(p => ({ ...p, [k]: e.target.checked ? 1 : 0 }))}
                            />
                            <span>{label}</span>
                        </label>
                    ))}

                    <div className="grid grid-cols-2 gap-3 pt-2">
                        <div>
                            <label className="block text-sm font-medium">Firma cacciatore</label>
                            <input className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.firma_cacciatore}
                                onChange={(e) => setD(p => ({ ...p, firma_cacciatore: e.target.value }))}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">Data firma</label>
                            <input type="date" className="mt-1 w-full border rounded-md px-3 py-2"
                                value={d.firma_data}
                                onChange={(e) => setD(p => ({ ...p, firma_data: e.target.value }))}
                            />
                        </div>
                    </div>

                    <div className="pt-2 flex flex-wrap gap-2">
                        <button
                            type="button"
                            onClick={save}
                            disabled={saving}
                            className="px-4 py-2 rounded-md bg-slate-900 text-white disabled:opacity-60"
                        >
                            {saving ? "Salvataggio..." : "Salva"}
                        </button>

                        <button
                            type="button"
                            onClick={() => { save().then(stampa); }}
                            disabled={saving}
                            className="px-4 py-2 rounded-md border border-slate-200"
                        >
                            Salva e stampa
                        </button>

                        <button
                            type="button"
                            onClick={stampa}
                            className="px-4 py-2 rounded-md border border-slate-200"
                        >
                            Stampa
                        </button>
                    </div>
                </div>
            </div>
        </Page>
    );
}
